<template>
  <div class="expired-page">
    <Empty />
  </div>
</template>

<script>
import Empty from '@/components/empty.vue'

export default {
  name: 'Expired',
  components: { Empty },
}
</script>

<style lang="scss" scoped>
.expired-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  background-color: var(--color-10);
}
</style>
